// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.5 1C15.567 1 14 2.567 14 4.5C14 5.02351 14.1156 5.52226 14.3231 5.97018L5.97018 14.3231C5.52226 14.1156 5.02351 14 4.5 14C2.567 14 1 15.567 1 17.5C1 18.9878 1.92751 20.2573 3.23565 20.7644C3.74271 22.0725 5.01224 23 6.5 23C8.433 23 10 21.433 10 19.5C10 18.9767 9.88452 18.4781 9.67715 18.0303L18.0303 9.67715C18.4781 9.88452 18.9767 10 19.5 10C21.433 10 23 8.433 23 6.5C23 5.01224 22.0725 3.74271 20.7644 3.23565C20.2573 1.92751 18.9878 1 17.5 1Z"}}]};

const BoneFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bone-filled',
    ref,
    icon: element,
  },
));

BoneFilledIcon.displayName = 'BoneFilledIcon';

export default BoneFilledIcon;
